import UpdateNotes from './UpdateNotes'

export default UpdateNotes